import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Footer from "../../Flight/components/Home Footer/Footer";
import classes from "../../../components/Flight/components/Services/Services.module.css";
import "./aboutUs.css";

const Terms = () => {
  return (
    <>
      <Grid
        container
        style={{ display: "flex", alignItems: "start" }}
        justifyContent="space-between"
      >
        <div
          className={classes["service-container"]}
          style={{ background: "var(--themegreen)" }}
        >
          <div className={classes["services"]}>
            <Typography
              variant="h5"
              style={{
                color: "#fff",
                textTransform: "capitalize",
                fontSize: "1.875rem",
                fontWeight: "700",
                paddingLeft: "8px",
              }}
            >
              Terms of use
            </Typography>
          </div>
        </div>
        <div
          style={{
            maxWidth: "70%",
            margin: "0 auto",
            textAlign: "start",
            marginTop: "3rem",
          }}
        >
          <Typography component="p" style={{ marginBottom: "0.875rem" }}>
            These general terms and conditions (“T&Cs”) apply between you (“You”
            or the “Customer”) and Gotogate International AB (“We” or “Us”), the
            operator of the booking portal travelpick.io (hereinafter referred
            to as the “Portal”). It is requested that You read these T&Cs
            carefully prior to using the Portal. By using the Portal, You agree
            to these T&Cs. If You do not accept these T&Cs, We ask that You
            refrain from using the Portal and exit the website.
          </Typography>
          <Typography component="p" style={{ marginBottom: "0.875rem" }}>
            If you purchase a package travel that is covered by the Package
            Travel Act , only Appendix 1 and Chapter 8 of these General Terms
            and Conditions apply (the latter only if one or more of our own
            services are included in your package travel).
          </Typography>
          <Typography component="p" style={{ marginBottom: "0.875rem" }}>
            {" "}
            You must be at least 18 years of age and act in your role as a
            private consumer to make a booking on the Portal. A private consumer
            is, as opposed to a business, a natural person who enters into a
            legal transaction for purposes which are predominantly outside its
            commercial and/or self-employed activities.
          </Typography>
          <Typography component="p" style={{ marginBottom: "0.875rem" }}>
            {" "}
            The operator of the Portal and your contractual partner for using
            the Portal is:
          </Typography>
          <Typography component="p" style={{ marginBottom: "0.5rem" }}>
            <strong>{React.env.address}</strong>
          </Typography>
          <Typography component="p" style={{ marginBottom: "0.5rem" }}>
            <strong>Telephone: </strong>
            {React.env.mobile}
          </Typography>
          <Typography component="p" style={{ marginBottom: "0.875rem" }}>
            <strong>Email: </strong>
            {React.env.email}
          </Typography>
          <p>The T&amp;Cs are set out as follows:</p>
          <h2>
            <strong> Table of content</strong>
          </h2>
          <ol className="toc">
            <li>
              <a href="#SCOPE_OF_SERVICE">SCOPE OF SERVICE</a>
            </li>
            <li>
              <a href="#BOOKING_PROCESS">
                BOOKING PROCESS AND CONTACT INFORMATION
              </a>
            </li>
            <li>
              <a href="#MEDIATION_FLIGHTS">MEDIATION OF FLIGHTS</a>
            </li>
            <li>
              <a href="#MEDIATION_HOTEL">MEDIATION OF HOTEL BOOKINGS</a>
            </li>
            <li>
              <a href="#MEDIATION_RENTAL_CAR">
                MEDIATION OF RENTAL CAR BOOKINGS
              </a>
            </li>
            <li>
              <a href="#SPECIAL_PROVISIONS">
                SPECIAL PROVISIONS FOR THE MEDIATION OF BOOKINGS OF MULTIPLE
                SERVICES
              </a>
            </li>
            <li>
              <a href="#INFORMATION_PASSPORT_VISA">
                INFORMATION ON PASSPORT, VISA AND HEALTH PROVISIONS
              </a>
            </li>
            <li>
              <a href="#OUR_SERVICES">OUR OWN SERVICES</a>
            </li>
            <li>
              <a href="#CHARGES_PAYMENT">CHARGES AND PAYMENT</a>
            </li>
            <li>
              <a href="#COMPLAINTS">CLAIMS</a>
            </li>
            <li>
              <a href="#CUSTOMER_RIGHTS">
                CUSTOMER RIGHTS PURSUANT TO India REGULATION
              </a>
            </li>
            <li>
              <a href="#LIABILITY">LIABILITY</a>
            </li>
            <li>
              <a href="#GOVERNING_LAW">GOVERNING LAW AND DISPUTE RESOLUTION</a>
            </li>
            <li>
              <a href="#DATA_PROTECTION">DATA PROTECTION</a>
            </li>
            <li>
              <a href="#PORTAL_RANKING">PORTAL RANKING AND SORTING OPTIONS</a>
            </li>
          </ol>
          <p>
            <a href="#APPENDICES_FEES">
              APPENDIX 1 – FEES FOR ADMINISTRATIVE ASSISTANCE&nbsp;
            </a>{" "}
          </p>
          <ol className="main-list">
            <li>
              <span class="headterm1">
                <a name="SCOPE_OF_SERVICE"></a>SCOPE OF SERVICE
              </span>
              <ol>
                <li>
                  <span class="subterm1">Mediation of Travel Services</span>
                  <ol>
                    <li>
                      For the flight, hotel, insurance, train and car rental
                      services offered on the Portal (collectively referred to
                      as “Travel Services”), We exclusively act within our
                      capacity as an intermediary. To that end, our role and
                      obligations are limited to mediating Travel Services that
                      will be rendered by third parties such as airlines, travel
                      operators, hotels, insurers, car rental companies or other
                      service providers (hereinafter in each case “Service
                      Provider”).
                    </li>

                    <li>
                      Consequently, the agreement for the actual provision of
                      Travel Services (e.g. transport contract, insurance
                      contract, rental agreement) comes into effect directly
                      between You and the relevant Service Provider. We are not
                      a co-vendor of the Travel Services and We are not a party
                      to the contractual relationship between You and the
                      Service Provider.{" "}
                    </li>

                    <li>
                      By using the Portal to purchase Travel Services, You
                      authorize Us to mediate with the corresponding Service
                      Provider(s) on your behalf, including mediation of the
                      payment for these Travel Services, in order to take care
                      that the transaction between You and the Service
                      Provider(s) is carried out. The price issued for the
                      actual Travel Services may include a commission for the
                      services we render for mediating the agreement between you
                      and the relevant Service Provider.
                    </li>
                    <li>
                      Responsibility for the actual performance of the Travel
                      Services mediated through the Portal is exclusively held
                      by the relevant Service Provider. In our role as an
                      intermediary, We do not assume any responsibility for the
                      Travel Services to be rendered by the Service Providers
                      and We make no representations or warranties (neither
                      expressed nor implied) regarding the suitability or
                      quality of Travel Services mediated on the Portal. For any
                      claim You may have in context with the performance or
                      non-performance of the Travel Service, the Service
                      Provider is the responsible addressee.{" "}
                    </li>
                    <li>
                      Should You have the opportunity to request special wishes
                      (such as special meals, disabled facilities or child
                      seats) when booking Travel Services, We will pass on your
                      request to the relevant Service Provider. However, We
                      cannot take any responsibility on whether the Service
                      Provider can actually fulfil such wishes.
                    </li>
                  </ol>
                </li>
                <li>
                  <span class="subterm1">Our own Services</span>
                </li>
                <span class="traveltermsText">
                  Apart from mediating Travel Services as stated in Section 1.1
                  above, there are also additional services (other than Travel
                  Services) available through the Portal which We, ourselves,
                  are responsible for providing. For such additional services,
                  You enter into a direct contractual relationship with Us. In
                  each case, we clearly inform you if and to what extent we
                  offer own services instead of only mediating third party
                  services.
                </span>
                <span class="traveltermsText">
                  Our own portfolio of services may vary over time. Some of our
                  own services are described in Section 8. For additional
                  services not set forth in these T&amp;C’s, a detailed
                  description of such additional services as well as information
                  about our fees and supplementary terms and conditions for
                  booking and usage, is provided to You over the course of the
                  booking process.{" "}
                </span>
                <li>
                  <span class="subterm1">
                    Applicable contractual conditions
                  </span>
                  <ol>
                    <li>
                      These T&amp;Cs apply to the mediation of Travel Services
                      according to Section 1.1 as well as for our own services
                      pursuant to Section 1.2.{" "}
                    </li>
                    <li>
                      For the agreement between You and the relevant Service
                      Provider (Section 1.1.2), the general terms and conditions
                      of the relevant Service Provider (such as conditions of
                      carriage, transfer conditions, insurance conditions or the
                      like), as issued by the Service Provider apply. Such
                      general terms and conditions of the relevant Service
                      Provider will be notified to you over the course of the
                      booking process. As the Service Provider’s terms and
                      conditions may include provisions relating to liability,
                      cancellation, changes of bookings and refunds (if
                      available) and other restrictions, You are advised to read
                      those terms carefully.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="BOOKING_PROCESS"></a>BOOKING PROCESS AND CONTACT
                INFORMATION
              </span>
              <ol>
                <li>
                  During the booking process, You are provided with the
                  technical means needed to detect errors in entry forms and to
                  correct them prior to submitting your booking request. You are
                  requested to check all data for accuracy before concluding
                  your booking request. Subsequent change requests may lead to
                  significant additional costs.
                </li>
                <li>
                  We might need to contact You, e.g. in case of subsequent
                  changes to the purchased Travel Services. You must submit
                  accurate contact information such as your telephone number and
                  email address. You must also continuously check if You have
                  received a message from Us. <br /> <br />
                  It is also your responsibility to ensure that You are able to
                  receive our messages. We are not responsible if You do not
                  receive a message from Us due to circumstances reasonably
                  outside of our control including, but not limited to the
                  following: (i) You gave us an incorrect email address; (ii)
                  your email settings won’t allow our email to reach You; or
                  (iii) your email settings treat our email as spam.
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="MEDIATION_FLIGHTS"></a>MEDIATION OF FLIGHTS
              </span>
              <ol>
                <li>
                  <span class="subterm1">
                    Conclusion of contract and price changes
                  </span>
                  <ol>
                    <li>
                      After You submitted your booking request, We will confirm
                      receipt of your request via email. This is the moment that
                      the mediation contract between You and Us comes into
                      existence. If You do not receive such confirmation within
                      one hour of completing your booking request, and none of
                      our operators has contacted you by email or telephone to
                      indicate any problems, please contact us by telephone for
                      verification.{" "}
                    </li>
                    <li>
                      As soon as your requested tickets have been issued, You
                      will receive a confirmation email with a ticket number.
                      This is the moment a binding contract between You and the
                      relevant airline(s) has been concluded.{" "}
                    </li>
                    <li>
                      {" "}
                      Prices for the flight and seat availability are added
                      directly in the Portal by the applicable airline. If
                      changes are made by the airline that are outside of our
                      control (e.g. price changes, seat availability or
                      something else) and that occur after a booking request has
                      been made, but before the contract with the airline has
                      become binding (as set out in Section 3.1.2 above), the
                      contract will not enter into force and your payment will
                      be refunded in full. We may contact You and give You the
                      option to accept the changed price during ordinary opening
                      hours, however no later than 24 hours after We have been
                      made aware of the price change or the first weekday
                      following such 24-hour period.
                    </li>
                  </ol>
                </li>
                <li>
                  <span class="subterm1">
                    Information on booking and transport conditions
                  </span>
                  <ol>
                    <li>
                      Regarding the flights offered on the Portal, We
                      exclusively act within our capacity as an intermediary.
                      The agreement for the performance of the flight comes into
                      effect directly between You and the relevant airline and
                      We do not accept any contractual responsibility related to
                      the performance or non-performance of your flight. The
                      operating airline is solely responsible for performance /
                      non-performance of your flight.
                    </li>
                    <li>
                      Before You conclude the booking, the terms and conditions
                      of the relevant airline(s) will be made available to You.{" "}
                    </li>
                    <li>
                      When mediating Travel Services rendered by airlines, We
                      are not guaranteed access to the airline’s booking system.
                      Where this is the case, We may act on your behalf in
                      concluding the contract between You and the airline. We
                      may also ask You to contact the relevant airline directly
                      for questions on bookings, changes or cancellation of your
                      booking. If You have purchased our Flexible Ticket service
                      (see Section 8), all rebooking requests must however be
                      made through our customer service as set out in
                      Section8.1.4.You may receive two booking confirmations –
                      one from us and one from the relevant airline. If You have
                      received two booking confirmations,please use the booking
                      confirmation of the airline for check-in.
                    </li>

                    <li>
                      Below, by way of a general overview, We provide
                      information on conditions related to booking and transport
                      typically applied by airlines in such or at least a
                      similar way. However, any deviating provisions of the
                      relevant airline prevail over the general information
                      provided in this Section 3.2.4. Therefore, in each case,
                      please check the applicable terms and conditions of the
                      relevant airline prior to your booking.
                      <ul type="a">
                        <li>
                          Flight times/check in <br />
                          <span class="traveltermsText">
                            All flight times specified are local. Next-day
                            arrivals are indicated with a "+1" on the timetable.
                            The stated flight times are preliminary and subject
                            to change on short notice after the ticket has been
                            issued; for example, due to restrictions by flight
                            control, the weather, or functional restrictions by
                            the airline. Please keep yourself informed of the
                            current times well ahead of your flight.
                            <br />
                            <br />
                            Please comply with the check-in times stated by the
                            airline. The airlines are entitled to refuse
                            boarding if You are late for check-in. Kindly
                            observe that some airlines encourage check-in
                            through their own website as they may charge a
                            check-in fee when checking in manually at the
                            airport.{" "}
                          </span>
                        </li>
                        <li>
                          Combination of individual tickets
                          <br />
                          <span class="traveltermsText">
                            A combination of two separate one-way tickets
                            instead of a roundtrip ticket is clearly marked as
                            such during the booking procedure. The tickets are
                            treated independently from one another in the event
                            of cancellation, change, disruption of air traffic
                            such as strikes and changes to flight schedules.
                            Each airline's own regulations will apply.
                            <br />
                            <br />
                            Flight tickets with different booking numbers are
                            always regarded as journeys that are independent of
                            each other.
                          </span>
                        </li>
                        <li>
                          Flight tickets with several segments/order of use
                          <br />
                          <span class="traveltermsText">
                            Your roundtrip ticket or one-way ticket may consist
                            of several segments. According to the conditions of
                            most airlines, such flight segments are to be used
                            in sequence. If not, many airlines will refuse
                            transport on subsequent flight segments (e.g.
                            failure to use one segment of a journey could
                            invalidate the rest of the ticket). For roundtrip
                            tickets a no-show on Your outbound flight may result
                            in Your inbound flight being cancelled by the
                            airline{" "}
                          </span>
                        </li>
                        <li>
                          Pregnancy
                          <br />
                          <span class="traveltermsText">
                            Some airlines refuse to transport women who are past
                            week 28th of pregnancy at the time of the outward or
                            return flight. If you are pregnant You must clarify
                            with the airline and your doctor whether or not You
                            can commence the journey.
                          </span>
                        </li>
                        <li>
                          Infants and child tickets
                          <br />
                          <span class="traveltermsText">
                            Please contact the airline to obtain the conditions
                            for traveling with a child who does not have a
                            separate seat. Usually, children above the age of 2
                            years require a separate seat, while children
                            between the ages of 0 and 2 years travel as infants
                            and will not be allocated a seat of their own. If
                            the infant reaches the age of 2 before the end of
                            the trip, a child ticket must be booked for the
                            entire trip. Infant tickets cannot be booked before
                            birth, as the correct name and date of birth must
                            match those stated in the passport. We will not
                            reimburse any expenses that arise if the wrong type
                            of ticket is booked from the outset.
                          </span>
                        </li>
                        <li>
                          Unaccompanied minors
                          <br />
                          <span class="traveltermsText">
                            We do not mediate the booking of any tickets for
                            unaccompanied minors. Children under 18 years must
                            be booked for a journey in the company of an adult.
                            Some countries and airlines refuse entry to children
                            under 18 years unless accompanied by a legal
                            guardian. Please note that some airlines require
                            children under the age of 18 to bring a birth
                            certificate to travel.{" "}
                          </span>
                        </li>
                        <li>
                          Lost/damaged luggage
                          <br />
                          <span class="traveltermsText">
                            Within our capacity as an intermediary, We accept no
                            liability for lost or damaged luggage. Any problems
                            should be reported immediately to the representative
                            of the airline at the airport.
                          </span>
                        </li>
                        <li>
                          Transit and overnight accommodation
                          <br />
                          <span class="traveltermsText">
                            Generally, ground transportation and/or overnight
                            accommodation during your trip is not included in
                            the flight ticket price. You are personally
                            responsible for checking ground transportation
                            timetables and prices.
                          </span>
                        </li>
                        <li>
                          Connection times between flights
                          <br />
                          <span class="traveltermsText">
                            Standard tickets booked on the Portal have approved
                            connection times. The times required for making
                            connections between flights are calculated by the
                            airlines. If a flight segment is delayed and leads
                            to a missed connection, the airlines are obliged to
                            assist You in reaching your final destination (see
                            Section 11.1). <br />
                            When separate tickets are booked, the airlines bear
                            no responsibility for missed connections resulting
                            from delays. Therefore, it is your responsibility to
                            ensure that the connection time is sufficient
                            according to the airlines and airports. Any
                            additional costs incurred on account of missed
                            connections will not be reimbursed.
                          </span>
                        </li>
                        <li>
                          Double booking
                          <br />
                          <span class="traveltermsText">
                            A double booking means that two or more bookings
                            with the same passenger name have been made with the
                            same airline. If You have a double booking, the
                            airline may cancel the trip(s). This may also occur
                            if the bookings have been made with different travel
                            agencies. We are not responsible for cancellations
                            made by the airlines, nor for denied refunds from
                            airlines, in cases where they suspect a double
                            booking.{" "}
                          </span>
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
                <li>
                  <span class="subterm1">
                    Airlines banned from operating in the India (black list){" "}
                  </span>
                  <span class="traveltermsText">
                    Please note that certain airlines are prohibited from
                    operating within the India, according to a decision made by
                    the Indiaropean Commission in close consultation with the
                    national air transport authorities. Such airlines are
                    prohibited because they are considered unsafe or not subject
                    to adequate control by the authorities of their country.
                    <br />
                    You can check which airlines are affected by an operating
                    prohibition via the following link:
                  </span>
                  <br />
                </li>
                <li>
                  <span class="subterm1">
                    Timetable changes and cancellation by airlines{" "}
                  </span>
                  <ol>
                    <li>
                      Your agreement with the applicable airline may allow them
                      to cancel or amend your bookings. We will notify You of
                      any changes once We are informed of them by the airline.
                      <br />
                      <br />
                      If You wish to request a change or cancellation refund, as
                      an additional own service, We offer to handle the request
                      on your behalf if permitted by the conditions of the
                      airline.{" "}
                      <a href="#APPENDICES_FEES">
                        For a list of our fees, click here.{" "}
                      </a>
                    </li>

                    <li>
                      The flight times shown in your booking confirmation may
                      change between the date of your booking and the date You
                      actually travel. We recommend that you stay updated and
                      contact your airline at least 72 hours before the
                      scheduled departure of the flight to ensure that the
                      flight (and any connecting flights) will depart on
                      schedule. We have no control over airline’s schedule
                      changes and accept no responsibility for costs that may
                      arise as a result of such changes.
                    </li>
                  </ol>
                </li>
                <li>
                  <span class="subterm1">
                    Changes and cancellations requested by You
                  </span>

                  <ol>
                    <li>
                      The conditions for changing flight bookings (including
                      change of passenger name, destination, and date of travel)
                      and for providing cancellation refunds are set by the
                      relevant airline, which is your contractual partner for
                      providing the flight. We, as the intermediary, have no
                      influence over such conditions.
                    </li>
                    <li>
                      If You wish to make a change to your booking or request a
                      cancellation refund, as an additional own service, We
                      offer to handle the request on your behalf, provided that
                      the conditions of the airline permit such a change or
                      cancellation refund. During the process of booking such
                      additional services, we will inform You of any further
                      conditions and fees for such services.{" "}
                      <a href="#APPENDICES_FEES">
                        For a list of our fees, click here.{" "}
                      </a>
                    </li>
                    <li>
                      In order for us to be able to handle the changes requested
                      by You, it is necessary that We receive your change
                      requests at the latest 24 hours prior to the commencement
                      of travel (only by telephone). If You have purchased our
                      Flexible Ticket service, see section 8. <br />
                      <br />
                      For change requests at shorter notice, we recommend that
                      You contact the relevant airline directly.
                    </li>
                  </ol>
                </li>
                <li>
                  <span class="subterm1">
                    Non-Appearance or Non-Attendance of the Flight
                  </span>
                  <span class="traveltermsText">
                    If You do not appear for or attend your flight, You hereby
                    authorize us to request possible refunds from the airline on
                    your behalf. We are entitled but not obligated to do so and
                    any rights You have to request unclaimed refunds directly
                    from the airline remain unaffected.
                    <br />
                    <br />
                    If We do obtain refunds on your behalf, We will deduct our
                    fees from the amount obtained.{" "}
                    <a href="#APPENDICES_FEES">
                      For a list of our fees, click here.
                    </a>{" "}
                    We will retain any refunds obtained on your behalf, less our
                    fees, for 12 months following the date of the flight and You
                    will be able to request a transfer of this amount, less our
                    fees, at any time before the 12 month period has passed by
                    contacting our customer service.
                  </span>
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="MEDIATION_HOTEL"></a>MEDIATION OF HOTEL BOOKINGS
              </span>
              <span class="traveltermsText">
                All queries in connection with the booking and any change or
                cancellation request must therefore be made directly to
                Booking.com.{" "}
              </span>
            </li>
            <br />
            <br />

            <li>
              <span class="headterm1">
                <a name="MEDIATION_RENTAL_CAR"></a>MEDIATION OF RENTAL CAR
                BOOKINGS
              </span>
              <span class="traveltermsText">
                Rental car services booked via the Portal are mediated by
                Traveljigsaw Limited (“Rentalcars.com”). <br />
                <br />
                All queries in connection with the booking and any change or
                cancellation requests must therefore be made directly to
                Rentalcars.com. You can find the contact details for
                Rentalcars.com here:
                <br />
              </span>
            </li>
            <li>
              <span class="headterm1">
                <a name="SPECIAL_PROVISIONS"></a>SPECIAL PROVISIONS FOR THE
                MEDIATION OF BOOKINGS OF MULTIPLE SERVICES
              </span>
              <span class="traveltermsText">
                The Portal offers the possibility to mix and match multiple
                individual services as You wish. In this case, You instruct us
                to act as an intermediary for the booking of various travel
                services from various suppliers. The relevant suppliers will be
                clearly presented to You during the booking procedure before the
                booking is completed. In the event that You combine individual
                services, no travel contract is concluded between You and us;
                instead, You conclude several contracts for the provision of
                individual services with each separate supplier. In this case,
                We solely operate within our capacity as an intermediary in
                relation to each individual travel service.
              </span>
            </li>
            <li>
              <span class="headterm1">
                <a name="INFORMATION_PASSPORT_VISA"></a>INFORMATION ON PASSPORT,
                VISA AND HEALTH PROVISIONS
              </span>
              <ol>
                <li>
                  Passport, visa and/or health requirements can change and You
                  should therefore check with the relevant authority (embassy,
                  consulate etc.) well in advance of travel. It is your
                  responsibility to be in possession of a valid passport and, if
                  appropriate, a visa. It is important to remember to include
                  all transit points in your journey which may also require You
                  to obtain a visa. It can often take some time to obtain a
                  visa, so You are advised to apply well ahead of time. We
                  accept no responsibility for customers who do not possess the
                  correct documents.
                </li>
                <li>
                  Each destination has its own requirements as far as entry
                  formalities, vaccinations, etc. which can also vary depending
                  on the passenger's nationality. It is your responsibility to
                  collect that information. No incidents arising from the
                  failure to comply with such official regulations will be
                  considered our responsibility. We therefore urge You to always
                  verify the different formalities of the chosen destination or
                  transit countries, as well as the time needed to take all of
                  the related steps.
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="OUR_SERVICES"></a>OUR OWN SERVICES{" "}
              </span>
              <ol>
                <li>
                  <span class="subterm1">
                    <a name="rebookticket"></a>Flexible Ticket
                  </span>
                  <ol>
                    <li>
                      If purchased during the booking procedure, the Flexible
                      Ticket allows You to change date and/or time of your
                      flight booking under the terms set out in this section,
                      without paying our change fee and/or the airline’s change
                      fee. When providing our Flexible Ticket service, We only
                      mediate the transport contract between You and the
                      relevant airline. As the Flexible Ticket is our own
                      service (i.e. You cannot make use of our Flexible Ticket
                      service by contacting the airline directly) all rebooking
                      requests making use of the Flexible Ticket service must be
                      made via our customer service (see Section 8.1.4).
                    </li>

                    <li>
                      The Flexible Ticket allows flights to be rebooked under
                      the following conditions:
                      <ul>
                        <li class="termsbullet">
                          All rebookings must be made in accordance with Section
                          8.1.4 and at least 24 hours before the original time
                          of departure.
                        </li>
                        <li class="termsbullet">
                          Rebooking is only possible within the same airline,
                          i.e. a flight can only be rebooked to a flight
                          operated by the same airline as the one operating the
                          originally booked ticket.{" "}
                        </li>
                        <li class="termsbullet">
                          Flight segments must be used in the same order in
                          which they were originally booked.
                        </li>
                        <li class="termsbullet">
                          Upgrading to a different cabin, or booking class, on
                          the same flight is not permitted.
                        </li>
                        <li class="termsbullet">
                          Rebooking a ticket for a so called “stop-over” (i.e.
                          staying in a connection city longer than originally
                          booked) is not permitted.
                        </li>
                        <li class="termsbullet">
                          A change of origin and/or destination is not possible,
                          neither for the outbound nor the return flight.
                        </li>
                        <li class="termsbullet">
                          The Flexible Ticket does not allow any names to be
                          changed or corrected.
                        </li>
                        <li class="termsbullet">
                          A journey can only be rebooked once. Once the change
                          has been confirmed, the Flexible Ticket has been used
                          up.
                        </li>
                        <li class="termsbullet">
                          In case of rebooking, the journey must be completed
                          within one year from the time of original booking. The
                          new trip may not commence within 24 hours from the
                          time of change request.
                        </li>
                        <li class="termsbullet">
                          The booking is non-refundable once the Flexible Ticket
                          service has been used.
                        </li>
                      </ul>
                    </li>
                    <li>
                      The Flexible Ticket must be booked and paid for during the
                      booking process and cannot be added afterwards.{" "}
                    </li>
                    <li>
                      If You want to rebook your ticket, You have to contact our
                      customer service by phone during our ordinary opening
                      hours.{" "}
                      <a target="_blank" href="/rf/contact-us">
                        You can find our phone number under “Contact Us –
                        Phone”.&nbsp;
                      </a>
                      " <br />
                      <br />
                      Please note that we communicate in English by phone and
                      email.
                    </li>
                    <li>
                      Rebooking is only completed once We have confirmed it by
                      e-mail. If You do not receive a confirmation, please
                      contact our customer service.{" "}
                    </li>
                    <li>
                      The rebooking of flights using the Flexible Ticket service
                      is subject to availability. If the desired change results
                      in a more expensive ticket, or if the change leads to the
                      passenger no longer being entitled to a special price
                      (e.g. for a small child), You have to bear the additional
                      costs yourself. We are not responsible for the effects
                      rebooking may have on any additional services concluded
                      directly with the airline (such as booking of additional
                      luggage or seat reservations).
                    </li>
                    <li>
                      If You cancel the flight, the price for the Flexible
                      Ticket service will not be refunded.{" "}
                    </li>
                    <li>
                      If You do not turn up for a segment of the journey, the
                      rebooking option through the Flexible Ticket service will
                      no longer be valid.
                    </li>
                  </ol>
                </li>

                <li>
                  <span class="subterm1">
                    <a name="selftranfer"></a>Self-transfer Guarantee
                  </span>
                  <ol>
                    <li>
                      If our connection guarantee assistance services as
                      outlined in this section 8.2 (hereinafter referred to as
                      the "<strong>Self-transfer Guarantee</strong>") is
                      included in your booking this will be clearly stated
                      during the booking process and on your booking
                      confirmation. If your booking also includes other flight
                      connections, please note that the Self-transfer Guarantee
                      only applies for the part of your booking that is marked
                      with "self-transfer".
                    </li>

                    <li>
                      With the exception of the exclusions below, the
                      Self-transfer Guarantee applies in the following cases
                      (each a "Change"):
                      <ul>
                        <li class="termsbullet">
                          in case any of your flight(s) are rescheduled, delayed
                          or cancelled by the respective airline causing you to
                          miss the flight(s) to your destination;
                        </li>
                        <li class="termsbullet">
                          if you miss a connecting flight due to baggage delays
                          or losses outside your reasonable control; and
                        </li>
                        <li class="termsbullet">
                          if you miss a connecting flight because of customs- or
                          immigration processes outside your reasonable control.{" "}
                        </li>
                      </ul>
                    </li>

                    <li>
                      The Self-transfer Guarantee does not apply:
                      <ul>
                        <li class="termsbullet">
                          if the Change only affects flight(s) within the same
                          ticket (issued as one e-ticket/PNR). The airline
                          providing the flight(s) is responsible for any issues
                          and for managing the Flight Changes (you may contact
                          the applicable airline directly for assistance and/or
                          questions);
                        </li>
                        <li class="termsbullet">
                          if the Change is due to force majIndiare situations,
                          meaning circumstances outside the airline’s reasonable
                          control such as (without limitation) political
                          instability, extreme weather conditions, security
                          risks, strikes, major limitation of airport operation
                          and/or airline bankruptcy/insolvency;
                        </li>
                        <li class="termsbullet">
                          for any action (or lack of action) which is reasonably
                          within your control, including for example if you miss
                          a flight because (i) you don’t have an appropriate
                          visa, travel documents or any other documentation
                          required for your travel; or (ii) you breach any
                          airline rules and restrictions; or{" "}
                        </li>
                        <li class="termsbullet">
                          • if you travel with a checked baggage despite booking
                          a self-transfer trip marked with “no checked bag”,
                          i.e. a self-transfer trip with a short connection
                          time; or{" "}
                        </li>
                        <li class="termsbullet">
                          if you have made changes to your Booking without our
                          previous approval.{" "}
                        </li>
                      </ul>
                    </li>
                    <li>
                      Inform Us without undue delay.
                      <br />
                      If You want to use the Self-transfer Guarantee You must
                      inform Us without undue delay by telephone after You are
                      aware of a Change. See preamble for contact details.
                      Should You not inform Us without undue delay, You will not
                      be entitled to use the Self-transfer Guarantee.
                    </li>
                    <li>
                      Self-transfer Guarantee Assistance – alternative flight(s)
                      or refund.
                      <br />
                      After We have been informed about the Change, We will
                      offer You to choose from one of the following options:{" "}
                      <br />
                      a) alternative flight(s) to your final destination at our
                      expense (the exact flight(s) offered by us will be
                      communicated to You); <br />
                      b) a refund of the price You paid for the unused flight(s)
                      at the time of your booking; or
                      <br />
                      c) flight(s) for returning to the airport of Your
                      departure at our expense (the exact flight(s) offered by
                      us will be communicated to You).
                      <br />
                      <br />
                      In case We cannot offer You reasonable flight(s) to your
                      final destination we may refer You to alternative
                      airports. In such case We will cover your costs for
                      transportation to the alternative airport. <br />
                      <br />
                      If there are more than 48 hours until the affected
                      flight’s original departure time We will decide upon one
                      option set forth in 8.2.5. in our sole discretion.
                    </li>
                    <li>
                      Your acceptance of the offered assistance
                      <br />
                      You must respond with your choice as soon as possible
                      after receiving more information from us on your options
                      set out in subsection 5 (a)-(c) above. If We do not
                      receive your answer within a reasonable time (in any case
                      not more than 24 hours) your right to use the
                      Self-transfer Guarantee is depleted.
                    </li>
                    <li>
                      Additional Compensations
                      <br />
                      In addition to your rights detailed in this Section 8.2,
                      the Self-transfer Guarantee entitles You to the following:
                      <ul>
                        <li class="termsbullet">
                          <strong>Accommodation</strong> – If a Change occurs
                          with short notice leaving You without accommodation
                          for the night (22:00-08:00), We will cover your costs
                          for accommodation for one or several nights. The
                          compensation is limited to a total of 100 USD per
                          passenger covered by the Self-transfer Guarantee. Any
                          compensation for accommodation that You receive from
                          the airline will be deducted from the Self-transfer
                          Guarantee refund.
                        </li>
                        <li class="termsbullet">
                          <strong>Meal &amp; Beverage</strong> – If a Change
                          leads to your flight(s) being delayed by more than 4
                          hours, We will cover the cost of meal and beverages up
                          to a total of 12 USD per passenger covered by the
                          Self-transfer Guarantee. Any compensation for meal
                          and/or beverages that You receive from the airline
                          will be deducted from the Self-transfer Guarantee
                          refund.{" "}
                        </li>{" "}
                      </ul>
                      Note that You will need to cover the expenses and provide
                      Us with receipt(s) for such expenses.
                    </li>
                  </ol>
                </li>
                <li>
                  <span class="subterm1">
                    <a name="cancellationguarantee"></a>Cancellation Guarantee
                  </span>
                  <ol>
                    <li>
                      If the Cancellation Guarantee is purchased during the
                      booking procedure, You can for any reason contact us after
                      Your flight booking to cancel Your flights and instead
                      receive an electronic voucher corresponding to 90% of the
                      flight price. The voucher can then be used for a new
                      booking on the Portal. The terms in this Section 8.3 apply
                      to our own service ‘Cancellation Guarantee’, while We are
                      acting within our capacity as an intermediary between You
                      and the relevant Service Provider. As the Cancellation
                      Guarantee is our own service (i.e. You cannot use the
                      Cancellation Guarantee by contacting the Service Provider
                      directly), all requests under the Cancellation Guarantee
                      must be made via our customer service (see Section 8.3.5).
                      We do not charge administrative fees in the event of a
                      voluntary cancellation using the Cancellation Guarantee or
                      in the event of a new booking with a voucher through our
                      Portal.
                    </li>
                    <li>
                      The following applies when using the Cancellation
                      Guarantee:
                      <ul>
                        <li class="termsbullet">
                          All cancellations must be made in accordance with
                          Section 8.3.5 and must be received by us no later than
                          4 hours before the original time of departure.
                        </li>
                        <li class="termsbullet">
                          The value of the voucher corresponds to 90% of the
                          value of the canceled flight ticket, including taxes
                          and the Service Provider's fees but excluding the
                          costs of the Cancellation Guarantee and any additional
                          services (e.g. extra baggage, seating etc.). If the
                          booking has previously been subject to changes that
                          have resulted in an increase in the price of the
                          flight ticket (e.g. voluntary date change, name
                          change, additional baggage etc.), the value of the
                          voucher is calculated based on the original flight
                          ticket only. When using the Cancellation Guarantee,
                          the value of the voucher can never exceed 208369 INR
                          per person or 416738 INR per booking, regardless of
                          the value of the flight tickets.
                        </li>
                        <li class="termsbullet">
                          You have the right to cancel Your flight ticket and
                          receive a voucher for any reason, however in
                          accordance with these terms. Cancellation can also be
                          requested for an individual passenger in the booking,
                          in this case the value of the voucher is calculated in
                          proportion to the number of passengers who cancel.
                          Cancellation cannot be made for part of the trip
                        </li>

                        <li class="termsbullet">
                          The voucher can only be used on our Portal in
                          accordance with the instructions that are received
                          with Your voucher. The voucher cannot be combined with
                          other vouchers, with cash refunds or with promotions
                          and cannot be used if entering the Portal via price
                          comparison sites.
                        </li>
                        <li class="termsbullet">
                          {" "}
                          You can only use Your voucher once. Any unused voucher
                          amount is thereafter considered forfeited.
                        </li>
                        <li class="termsbullet">
                          The voucher is valid for 12 months from the time You
                          receive Our notification of the voucher being
                          available for use, which is within 7 business days
                          from the time We have confirmed Your cancellation
                          request. When the validity period expires, the voucher
                          loses its value and You cannot claim compensation in
                          any other way.
                        </li>
                        <li class="termsbullet">
                          {" "}
                          A Cancellation Guarantee voucher can only be used for
                          booking of flights and not for other services made
                          available on the Portal (such as hotels or rental
                          cars).
                        </li>
                      </ul>
                    </li>

                    <li>
                      By using the Cancellation Guarantee to cancel Your booking
                      / flight ticket, You and Your fellow passengers waive all
                      rights to the travel documents that We have mediated to
                      the Service Provider. By purchasing the Cancellation
                      Guarantee service You accept that We, following Your
                      cancellation request, automatically acquire all rights to
                      the flight ticket and the booking and the right to use
                      these rights vis-à-vis the Service Provider.
                    </li>
                    <li>
                      The Cancellation Guarantee cannot be used if the Service
                      Provider is unable to provide the Travel Service after
                      being declared bankrupt or after having paused or closed
                      down their business (in such case the cost of the
                      Cancellation Guarantee service is not reimbursed).
                    </li>
                    <li>
                      If You want to use the Cancellation Guarantee, You must
                      contact our customer service. You can find our phone
                      number and other means of contact on the Portal. Please
                      note that We handle all customers in turn{" "}
                    </li>
                    <li>
                      The Cancellation Guarantee does not apply if you contact
                      the airline to rebook your flight ticket and request a
                      cancellation.{" "}
                    </li>
                  </ol>
                </li>

                <li>
                  <span class="subterm1">
                    <a name="cancelforanyreason"></a>Cancel for any reason
                  </span>
                  <ol>
                    <li>
                      Subject to what is set out in Section 8.4.4. below and if
                      Cancel For Any Reason is purchased during the booking
                      procedure, You can for any reason cancel your flights and
                      get a refund. As Cancel For Any Reason is our own service
                      (i.e. You cannot use Cancel For Any Reason by contacting
                      the Service Provider directly), all requests under Cancel
                      For Any Reason must be made in accordance with Section
                      8.4.2.
                    </li>
                    <li>
                      The following applies when using Cancel For Any Reason:
                      <ul>
                        <li class="termsbullet">
                          All cancellations must be made by contacting our
                          customer service via phone and must be received by Us
                          no later than 4 hours before the originally scheduled
                          time of departure of your first scheduled flight. If
                          You cancel later than that, Cancel For Any Reason will
                          not apply. Cancellation cannot be made for part of the
                          trip.
                        </li>
                        <li class="termsbullet">
                          Cancellation under Cancel For Any Reason can only be
                          used for the entire booking, i.e. for all passengers
                          and all flights under the booking.{" "}
                        </li>
                        <li class="termsbullet">
                          If cancellation is made in accordance with this
                          Section 8.4, You will get a refund of the entire
                          payment made to us for your booking except the cost
                          for Cancel For Any Reason. The refund is limited to a
                          total of 2,500 IndiaR per person regardless of the
                          amount paid for the booking.
                        </li>
                        <li class="termsbullet">
                          If You have a right to be refunded, your refund will
                          be processed using the same form of payment as used to
                          pay for the booking. We will initiate payment within
                          48 hours.
                        </li>
                      </ul>
                    </li>
                    <li>
                      By using Cancel For Any Reason to cancel your
                      booking/flight ticket, You and Your fellow passengers (as
                      the case may be) waive all rights to the travel documents
                      that We have mediated to the Service Provider. By
                      purchasing Cancel For Any Reason, You accept that We,
                      following your cancellation request, automatically acquire
                      all rights to the flight ticket and the booking and the
                      right to use these rights vis-à-vis the Service Provider.
                    </li>
                    <li>
                      In addition to the above, Cancel For Any Reason does not
                      apply and cannot be used:
                      <ul>
                        <li class="termsbullet">
                          if the flight or flights have been canceled, rebooked
                          or otherwise changed (i.a. changed name) via the
                          airline;
                        </li>
                        <li class="termsbullet">
                          if the Service Provider is unable to provide the
                          Travel Service after declaring bankruptcy or after
                          having paused or closed down their business (in such
                          case the cost of Cancel For Any Reason is not
                          reimbursed); or
                        </li>
                        <li class="termsbullet">
                          in case of force majIndiare situations, meaning
                          circumstances outside the airline’s reasonable control
                          such as (without limitation) political instability,
                          extreme weather conditions, security risks, strikes,
                          major limitation of airport operation, epidemics and
                          pandemics.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
              </ol>
            </li>

            <li>
              <span class="headterm1">
                <a name="CHARGES_PAYMENT"></a>CHARGES AND PAYMENT
              </span>
              <ol>
                <li>
                  <span class="subterm1">Payment</span>
                  <ol>
                    &nbsp;
                    <li>
                      Payment for Travel Services is either processed by us or
                      affiliates part of our corporate group (in cooperation
                      with our payment service provider(s) who supply the
                      payment processing functionality), or by the Service
                      Provider. All payment information belonging to our
                      customers is encrypted in a secure server when shared with
                      our payment service provider(s).
                    </li>
                    <li>
                      Depending on booking criteria and added services, the
                      payment may be split into two separate transactions, one
                      charge from us and another one from the Service Provider.
                      You will not be charged more than the actual total price
                      displayed on our site. The same security measures are
                      applied. In some cases, prices and fees from Service
                      Providers may not be in the currency displayed on the
                      Portal. Instead we provide an estimate in the default
                      currency of the Portal. As a result, when you make a
                      booking with credit card, the amount charged by the
                      Service Provider might be slightly different due to
                      currency fluctuations, conversion and possible fees
                      imposed by the card provider. If the previous may apply to
                      your booking you will be informed of this during the
                      booking procedure.
                    </li>
                    <li>
                      In order for us to be able to process your payment, You
                      need to ensure that there are sufficient funds available.
                      In the event of any problem arising related to the
                      processing of your payment, We will retry the processing
                      of your payment in cooperation with our payment service
                      provider(s). Should this not result in a fulfilled
                      withdrawal of funds from You, We will contact You as soon
                      as possible for instructions on other means of payment.
                      Should We not receive your payment after such further
                      instructions, your outstanding payment will be referred to
                      a debt collection company.
                    </li>
                  </ol>
                </li>
                <li>
                  <span class="subterm1">Payment fraud</span>
                  <br />{" "}
                  <span class="traveltermsText">
                    If there are reasons for us to suspect that fraud is being
                    committed, We reserve the right to refuse processing of such
                    payment. Legitimization of Payment may be demanded if a
                    crime is suspected. All types of payment fraud will be
                    reported to the police.
                  </span>
                  &nbsp;
                </li>

                <li>
                  <span class="subterm1">Refunds</span>
                  <ol>
                    <li>
                      Refunds are processed according to the terms and
                      conditions of the Service Provider. If You have a right to
                      be refunded, your refund will be processed using the same
                      form of payment as used to pay for the booking. Please
                      note that air fares contain different elements and not all
                      of them may be refundable, so even if You are eligible to
                      be refunded according to the Service Provider policies,
                      the refunded amount may not be exactly the total price
                      paid for your booking.
                    </li>
                    &nbsp;
                    <li>
                      All refunds are paid from the applicable Service Provider
                      and We, acting as the intermediary, have no influence over
                      the Service Provider’s handling times.
                    </li>
                    &nbsp;
                    <li>
                      As an intermediary We will only process a payment refund
                      where We have already received such from the applicable
                      Service Provider.
                    </li>
                    <li>
                      The total price of your booking will include the price of
                      the Travel Service(s), any add-on products and our service
                      fees. Please note that our service fees are
                      non-refundable. This is because the service fees are
                      charged for our mediation services which shall be
                      considered fulfilled when the booking has been confirmed
                      to You. Any Service Provider add-on products are
                      refundable only to the extent we have received relevant
                      amounts in return from the Service Provider. Our own
                      add-on products are non-refundable.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="COMPLAINTS"></a>CLAIMS
              </span>
              <ol>
                <li>
                  <span class="subterm1">
                    Claims relating to performance of Travel Services
                  </span>
                  <br />
                  <span class="traveltermsText">
                    Any problem, remark or claim relating to actual performance
                    of the Travel Services must be addressed directly to the
                    relevant Service Provider (travel operator, airline,
                    insurer, car rental company, hotel) with whom you hold the
                    contract for the relevant Travel Service. Please also see
                    section 11 for your rights pursuant to India regulation.
                  </span>
                </li>
                <li>
                  <span class="subterm1">
                    Claims relating to our own services
                  </span>
                  <br />
                  <span class="traveltermsText">
                    Claims relating to our own services are handled solely in
                    writing and are to be submitted within two months after the
                    end date of your trip.
                  </span>
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="CUSTOMER_RIGHTS"></a>CUSTOMER RIGHTS PURSUANT TO India
                REGULATION
              </span>
              <ol>
                <li>
                  <span class="subterm1">Cancelled or delayed flights</span>
                  <br />
                  <span class="traveltermsText">
                    If you are travelling into or out of the India, or on an
                    India carrier, you may have the right to demand
                    reimbursement for costs which you can assert directly
                    against the relevant airline in the event that your flight
                    is cancelled, delayed or you are denied boarding.{" "}
                  </span>
                </li>
                <li>
                  <span class="subterm1">Carrier liability</span>
                  <br />
                  <span class="traveltermsText">
                    The EC-Regulation (889/2002) on air carrier liability in the
                    event of accidents.{" "}
                  </span>
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="LIABILITY"></a>LIABILITY
              </span>
              <ol>
                <li>
                  You accept that We act as an intermediary between the You and
                  the Service Provider. We will under no circumstances be held
                  liable with respect to Travel Services You have booked with
                  one or more Service Providers and We do not accept any
                  liability for any inaccuracies in the information displayed on
                  the Portal which have been provided by the respective Service
                  Provider.
                </li>
                <li>
                  Should a Service Provider be unable to provide the Travel
                  Service for any reason, including without limitation due to
                  extraordinary events or circumstances beyond the control of
                  the Service Provider (force majIndiare) or where a Service
                  Provider declares for bankruptcy, We can only act as an
                  intermediary and refund payments where we have already
                  received such from the applicable Service Provider.
                </li>
                <li>
                  With regard to our own services, We are liable for damages
                  subject to the limitations set out in the T&amp;Cs and to the
                  extent permitted by law. We shall only be liable for direct
                  damages actually suffered, paid or incurred by You due to an
                  attributable shortcoming of our obligations in respect to our
                  own services , up to an aggregate amount of the cost of your
                  booking (whether for one event or a series of connected
                  events). If, due to reasons of extraordinary events or
                  circumstances beyond our control (force majIndiare), there are
                  deficiencies with reservations, confirmations and/or execution
                  of any bookings or services, We are exempt from any derived
                  legal responsibilities arising from such deficiencies or
                  non-compliances related to the effect of force majIndiare.
                </li>

                <li>
                  The limitation of liability set out in Section 12.3 also
                  applies to breaches of duty by persons for the fault of whom
                  We are responsible according to statutory provisions.
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="GOVERNING_LAW"></a>GOVERNING LAW AND DISPUTE RESOLUTION{" "}
              </span>
              <ol>
                <li>
                  <span class="subterm1">Governing law</span>
                  <br />
                  <span class="traveltermsText">
                    Swedish law applies exclusively to these T&amp;Cs and the
                    contract between You and us.
                    <br />
                    <br />
                    As a consumer, you will benefit from any mandatory
                    provisions of the law of the country in which you are
                    resident. Nothing in these T&amp;Cs, including this Section
                    13.1, affects your rights as a consumer to rely on such
                    mandatory provisions of local law.
                  </span>
                </li>
                <li>
                  <span class="subterm1">Online Dispute Resolution</span>
                  <br />
                  <span class="traveltermsText">
                    The Indiaropean Commission provides a platform for online
                    dispute resolution (ODS) under:{" "}
                  </span>
                </li>
              </ol>
            </li>
            <li>
              <span class="headterm1">
                <a name="DATA_PROTECTION"></a>DATA PROTECTION
              </span>
              <span class="traveltermsText">
                We take the protection of your personal data seriously. You can
                find detailed information about the collection, processing and
                use of your personal data in our{" "}
                <a href="/privacy-policy" class="termslinkout">
                  Privacy Policy
                </a>
                .{" "}
              </span>
            </li>
            <li>
              <span class="headterm1">
                <a name="PORTAL_RANKING"></a>PORTAL RANKING AND SORTING OPTIONS
              </span>
              <span class="traveltermsText">
                In order to make your search results as relevant as possible we
                are using complex algorithms to rank the flight alternatives and
                determine the order of display on our Portal. When you first see
                your search results they’ll be sorted by default as
                “Recommended” which accounts for lowest price, shortest flight
                duration and a combination of both (best value) as well as
                longest stay (earliest possible departure and latest possible
                return). It is also influenced by potential compensation we
                receive from the airline (if any).
                <br />
                <br />
                On the search result page you can decide how to sort the results
                and/or to filter the search results to display only your chosen
                preferences. We also offer the option to quickly rank the search
                results based on the following:
                <ul>
                  <li class="termsbullet" st="">
                    Cheapest - the cheapest price
                  </li>
                  <li class="termsbullet">
                    Shortest - the shortest travel time
                  </li>
                  <li class="termsbullet">
                    Campaign - any current market campaign we have with
                    airline(s), for which we may receive compensation from the
                    airline. If there is no active campaign the search results
                    in this category will be ranked based on the cheapest price.
                  </li>
                </ul>
              </span>
            </li>
          </ol>
        </div>
      </Grid>
      <Footer />
    </>
  );
};

export default React.memo(Terms);
